/** Shared, dependency-free environment endpoints for clients and build tooling. */
export interface EndpointConfig {
  readonly marketing: string;
  readonly app: string;
  readonly api: string;
  readonly docs: string;
  readonly status: string;
  readonly auth?: string;
  readonly download: string;
}

/** Production endpoint set for the canonical domain (prompt.md §39). */
export const PRODUCTION_ENDPOINTS: EndpointConfig = {
  marketing: "https://dayvise.com",
  app: "https://app.dayvise.com",
  api: "https://api.dayvise.com",
  docs: "https://docs.dayvise.com",
  status: "https://status.dayvise.com",
  auth: "https://auth.dayvise.com",
  download: "https://download.dayvise.com",
};

/** Legacy staging builds now target the preview stack. */
export const STAGING_ENDPOINTS: EndpointConfig = environmentEndpoints("preview");

export const LOCAL_ENDPOINTS: EndpointConfig = {
  marketing: "http://localhost:4321",
  app: "http://localhost:5173",
  api: "http://localhost:8787",
  docs: "http://localhost:4322",
  status: "http://localhost:4323",
  auth: "http://localhost:8787",
  download: "http://localhost:4324",
};

export type DayviseEnvironment = "production" | "dev" | "test" | "preview" | "staging" | "local";

function environmentEndpoints(environment: "dev" | "test" | "preview"): EndpointConfig {
  const root = `${environment}.dayvise.com`;
  return {
    marketing: `https://${root}`,
    app: `https://app.${root}`,
    api: `https://api.${root}`,
    docs: `https://docs.${root}`,
    status: `https://status.${root}`,
    auth: `https://api.${root}`,
    download: `https://download.${root}`,
  };
}

export function endpointsFor(environment: DayviseEnvironment): EndpointConfig {
  switch (environment) {
    case "production":
      return PRODUCTION_ENDPOINTS;
    case "dev":
    case "test":
    case "preview":
      return environmentEndpoints(environment);
    case "staging":
      return environmentEndpoints("preview");
    case "local":
      return LOCAL_ENDPOINTS;
  }
}

